import { useId } from 'react'
import { RobuscanLogotype } from './RobuscanLogotype'

export interface ILogotypeProps {
  /** Свёрнутое меню: только иконка */
  collapsed?: boolean
}

export const Logotype = ({ collapsed }: ILogotypeProps) => {
  // Логотип рендерится сразу в нескольких местах (шапка и сайдбар), и при одинаковых
  // id градиентов ссылки url(#…) ведут в первую копию. Если она под display:none,
  // браузер считает заливку недоступной и знак пропадает — поэтому id уникальные
  const instanceId = useId().replace(/:/g, '')
  const gradientId = (name: string) => `${instanceId}-${name}`

  if (process.env.REACT_APP_PROJECT === 'robuscan')
    return <RobuscanLogotype collapsed={collapsed} />

  return (
    <div className={'flex w-full items-center justify-center'}>
      <svg
        fill='none'
        height='36'
        viewBox={collapsed ? '0 0 46 64' : '0 0 166 64'}
        xmlns='http://www.w3.org/2000/svg'
      >
        {!collapsed && (
          <path
            d='M132.045 45.307c-2.936 0-3.775-1.303-3.928-3.295h10.755c.038-.652-.038-1.495-.115-2.108a6.77 6.77 0 0 0-1.945-3.756c-1.144-1.035-2.707-1.724-4.767-1.724-1.983 0-3.623.651-4.805 1.84-1.259 1.187-1.983 2.912-1.983 4.943 0 2.146.801 3.909 2.097 5.097 1.183 1.073 2.784 1.648 4.653 1.648 1.449 0 2.86-.345 4.004-1.035 1.145-.728 2.212-1.993 2.594-3.334h-3.051c-.458 1.265-1.03 1.724-3.509 1.724m-.038-8.316c1.411 0 2.326.269 2.898.843.611.537.839 1.38.916 2.223h-7.704c.076-.843.343-1.61.953-2.184.649-.575 1.564-.882 2.937-.882m-31.005 8.316c-2.937 0-3.776-1.303-3.928-3.295h10.716c.038-.652-.038-1.495-.114-2.108a6.77 6.77 0 0 0-1.945-3.756c-1.144-1.035-2.708-1.724-4.768-1.724-1.983 0-3.622.651-4.805 1.84-1.258 1.187-1.983 2.912-1.983 4.943 0 2.146.801 3.909 2.098 5.097 1.182 1.073 2.784 1.648 4.652 1.648 1.45 0 2.861-.345 4.005-1.035 1.144-.728 2.212-1.993 2.593-3.334h-3.051c-.419 1.265-.991 1.724-3.47 1.724m-.039-8.316c1.412 0 2.327.269 2.899.843.61.537.839 1.38.915 2.223h-7.704c.077-.843.344-1.61.954-2.184s1.525-.882 2.936-.882m-20.86 4.906v-7.128h2.631v7.051c0 1.533.153 2.184.648 2.721.496.575 1.335.805 2.594.805 1.144 0 2.02-.153 2.555-.728.496-.537.686-1.227.686-2.798v-7.051h2.67v7.128c0 1.954-.458 3.219-1.411 4.254-1.03 1.15-2.555 1.84-4.462 1.84-1.869 0-3.394-.652-4.462-1.802-.954-1.073-1.449-2.261-1.449-4.292m71.277-5.25h.114v-1.878h2.632v12.838h-2.632v-2.031h-.114q-.744 1.15-1.831 1.724c-.763.422-1.64.652-2.708.652-1.907 0-3.432-.728-4.5-1.916-1.106-1.227-1.678-2.913-1.678-4.906 0-2.07.725-3.832 1.983-5.02 1.144-1.111 2.479-1.686 4.272-1.686 1.029 0 1.983.23 2.669.613a6.4 6.4 0 0 1 1.793 1.61m-3.852 8.66c3.051 0 3.966-1.418 3.966-4.1 0-2.721-.953-4.14-3.966-4.14-3.051 0-4.005 1.419-4.005 4.14s.954 4.1 4.005 4.1M74.42 28.943v18.702h2.67V28.943zm42.866 5.48c1.983 0 3.585.729 4.653 1.993 1.03 1.188 1.563 2.836 1.563 4.753 0 1.916-.61 3.564-1.639 4.752-1.106 1.264-2.594 2.03-4.539 2.03-1.22 0-2.212-.306-2.974-.766-.649-.383-1.221-.881-1.64-1.571h-.153v7.205h-2.669v-18.05h2.669v1.916h.153a4.9 4.9 0 0 1 1.945-1.648c.801-.383 1.601-.614 2.631-.614m-.686 2.608c-2.746 0-3.967 1.303-3.967 4.177s1.221 4.1 3.967 4.1c2.974 0 3.966-1.226 3.966-4.1s-.992-4.177-3.966-4.177m47.328-2.261h1.83v2.759h-1.716c-1.487 0-2.364.23-2.898.881-.534.652-.725 1.303-.725 2.874v6.362h-2.708V34.77h2.594v2.184h.114c.343-.728.801-1.341 1.411-1.686.572-.345 1.182-.498 2.098-.498m-98.28-.345c1.793 0 3.28.69 4.348 1.8 1.144 1.227 1.793 2.99 1.793 4.983 0 1.878-.61 3.564-1.678 4.752a5.97 5.97 0 0 1-4.5 1.993c-1.22 0-2.213-.268-2.975-.767a6 6 0 0 1-1.602-1.456h-.114v1.878h-2.67V28.943h2.67V36.8h.114a5.2 5.2 0 0 1 1.907-1.725c.8-.422 1.64-.651 2.708-.651m-.686 10.883c2.784 0 3.928-.958 3.928-4.1 0-3.22-1.144-4.177-3.928-4.177-2.517 0-4.042.958-4.042 4.177 0 3.142 1.525 4.1 4.042 4.1'
            fill='#fff'
          />
        )}
        <path
          d='m20.587 12.158-3.814-3.794c-1.03-1.035-1.03-2.76 0-3.794L20.549.776a2.684 2.684 0 0 1 3.776 0l3.774 3.794c1.03 1.035 1.03 2.76 0 3.794l-3.776 3.794c-.99 1.073-2.707 1.073-3.736 0'
          fill='#3bffbe'
        />
        <path
          clipRule='evenodd'
          d='M24.371 35.844a2.656 2.656 0 0 0-3.757 0l-3.768 3.767a2.655 2.655 0 0 0-.007 3.75l3.762 3.785a2.657 2.657 0 0 0 3.763.006l3.781-3.78a2.654 2.654 0 0 0 0-3.756zM8.366 37.356c3.138-3.137 16.67-8.45 19.808-5.314l3.774 3.773a8.03 8.03 0 0 1 0 11.359l-3.782 3.78c-3.144 3.143-3.175 3.502-14.24 1.525'
          fill={`url(#${gradientId('a')})`}
          fillRule='evenodd'
        />
        <path
          clipRule='evenodd'
          d='M24.371 35.844a2.656 2.656 0 0 0-3.757 0l-3.802-3.802a8.035 8.035 0 0 1 11.362 0l3.774 3.773-3.803 3.801z'
          fill={`url(#${gradientId('b')})`}
          fillRule='evenodd'
        />
        <path
          clipRule='evenodd'
          d='M28.16 32.065a8.004 8.004 0 0 0-11.317 0l-3.774 3.773a7.997 7.997 0 0 0-.018 11.294l3.771 3.796a8.003 8.003 0 0 0 11.336.02l3.786-3.786a8 8 0 0 0 0-11.313zm-15.119-3.8c5.225-5.224 13.697-5.224 18.921 0l3.785 3.782c5.225 5.224 5.225 13.693 0 18.916L31.96 54.75c-5.238 5.236-13.734 5.221-18.953-.032l-3.77-3.796c-5.197-5.229-5.182-13.673.03-18.884z'
          fill={`url(#${gradientId('c')})`}
          fillRule='evenodd'
        />
        <path
          clipRule='evenodd'
          d='M31.932 28.284c-5.213-5.211-13.663-5.211-18.876 0l-3.77 3.769C4.087 37.25 4.073 45.674 9.254 50.89l3.769 3.793c5.206 5.241 13.682 5.255 18.908.032l3.782-3.781c5.213-5.212 5.213-13.66 0-18.87zM9.253 24.483c7.313-7.31 19.168-7.31 26.481 0l3.781 3.78c7.313 7.31 7.313 19.162 0 26.473l-3.782 3.781c-7.33 7.328-19.221 7.308-26.526-.045L5.44 54.68c-7.269-7.318-7.25-19.136.045-26.428z'
          fill={`url(#${gradientId('d')})`}
          fillRule='evenodd'
        />
        <path
          clipRule='evenodd'
          d='M30.04 33.95a5.33 5.33 0 0 0-7.537 0l-3.826 3.826-3.802-3.802L18.7 30.15c4.181-4.18 10.96-4.18 15.142 0l-1.201 1.201-2.598 2.605-.002-.003z'
          fill={`url(#${gradientId('e')})`}
          fillRule='evenodd'
        />
        <path
          clipRule='evenodd'
          d='M33.83 30.151c-4.167-4.164-10.922-4.164-15.088 0l-3.8 3.799-3.802-3.802 3.8-3.798c6.266-6.264 16.426-6.264 22.692 0z'
          fill={`url(#${gradientId('f')})`}
          fillRule='evenodd'
        />
        <defs>
          <linearGradient
            gradientUnits='userSpaceOnUse'
            id={gradientId('a')}
            x1='28.732'
            x2='16.815'
            y1='46.013'
            y2='36.711'
          >
            <stop stopColor='#1c74d8' />
            <stop offset='1' stopColor='#ba5dfc' />
          </linearGradient>
          <linearGradient
            gradientUnits='userSpaceOnUse'
            id={gradientId('b')}
            x1='29.48'
            x2='22.319'
            y1='36.181'
            y2='31.262'
          >
            <stop offset='.026' stopColor='#446fe1' stopOpacity='.69' />
            <stop offset='1' stopColor='#002a63' />
          </linearGradient>
          <linearGradient
            gradientUnits='userSpaceOnUse'
            id={gradientId('c')}
            x1='14.032'
            x2='32.148'
            y1='35.059'
            y2='51.79'
          >
            <stop stopColor='#673fa9' />
            <stop offset='1' stopColor='#1867c1' />
          </linearGradient>
          <linearGradient
            gradientUnits='userSpaceOnUse'
            id={gradientId('d')}
            x1='7.137'
            x2='38.989'
            y1='29.341'
            y2='52.649'
          >
            <stop stopColor='#2f2d71' />
            <stop offset='1' stopColor='#165dac' />
          </linearGradient>
          <linearGradient
            gradientUnits='userSpaceOnUse'
            id={gradientId('e')}
            x1='30.282'
            x2='17.721'
            y1='33.83'
            y2='31.691'
          >
            <stop stopColor='#4351b3' />
            <stop offset='1' stopColor='#ba5dfc' />
          </linearGradient>
          <linearGradient
            gradientUnits='userSpaceOnUse'
            id={gradientId('f')}
            x1='35.681'
            x2='17.079'
            y1='27.363'
            y2='27.791'
          >
            <stop stopColor='#214892' />
            <stop offset='1' stopColor='#673fa9' />
          </linearGradient>
        </defs>
      </svg>
    </div>
  )
}
